// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-upload .k-upload-files {\n  display: none !important;\n}\n\n.k-action-buttons {\n  display: none !important;\n}\n\n.k-clear-selected, .k-upload-selected {\n  display: none !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
